// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input } from '@angular/core';
import { ClientLocationPreference } from '@coa/app/home/modules/dashboard/modules/dashboard-location-preferences/services/location-preferences.response';

@Component({
  selector: 'coa-dashboard-location-preferences-chart',
  templateUrl: './dashboard-location-preferences-chart.component.html',
  styleUrls: ['./dashboard-location-preferences-chart.component.scss'],
})
export class DashboardLocationPreferencesChartComponent {
  @Input() clientLocationPreferences: ClientLocationPreference;
}
